module.exports = __webpack_public_path__ + "static/img/xiaoxi.23ae13f.png";


//////////////////
// WEBPACK FOOTER
// ./static/xiaoxi.png
// module id = 0Ee8
// module chunks = 1